/**
 * Загрузка и отображение результатов поиска
 * Orchestrator модуля results - загружает подмодули последовательно
 * 
 * Модули загружаются в правильном порядке:
 * 1. dependencies.js - зависимости (getCurrentLang, getNothingFoundText, escapeHtml, stripHtmlTags, initAccordion, initDictNameHandlers)
 * 2. state.js - состояние (activeSearchRequest, currentSearchId)
 * 3. dict-description.js - работа с описаниями словарей
 * 4. fragment-builder.js - создание фрагментов DOM
 * 5. results-count.js - показ количества результатов
 * 6. api-loader/ - модуль загрузки через API (state, utils, morphing, orchestrator)
 */

// ⛓️ CURSOR_ANCHOR:search:results-orchestrator

(function() {
  // Проверяем, что все зависимости загружены
  function checkDependencies() {
    return window.SEARCH_RESULTS_DEPS &&
           window.SEARCH_RESULTS_STATE &&
           window.SEARCH_RESULTS_DICT_DESC &&
           window.SEARCH_RESULTS_FRAGMENT &&
           window.SEARCH_RESULTS_COUNT &&
           window.SEARCH_RESULTS_API_LOADER;
  }
  
  // Инициализируем публичный API после загрузки всех модулей
  function initPublicAPI() {
    if (!checkDependencies()) {
      // Если модули еще не загружены, ждем немного и пробуем снова
      setTimeout(initPublicAPI, 10);
      return;
    }
    
    var apiLoader = window.SEARCH_RESULTS_API_LOADER;
    var fragmentBuilder = window.SEARCH_RESULTS_FRAGMENT;
    var resultsCount = window.SEARCH_RESULTS_COUNT;
    
    // Экспортируем глобально для обратной совместимости
    window.SEARCH_API = {
      loadSearchResults: apiLoader.loadSearchResults,
      createResultsFragment: fragmentBuilder.createResultsFragment,
      showResultsCount: resultsCount.showResultsCount
    };
  }
  
  // Инициализируем API после загрузки DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPublicAPI);
  } else {
    // DOM уже загружен, но модули могут еще загружаться
    setTimeout(initPublicAPI, 10);
  }
})();
